import React, { Component } from 'react';
import { Button, Card, CardBlock, CardTitle, Col, Form, FormGroup, Input, Label, Table } from 'reactstrap';
import Api from '../Api';
import SendStatus from './SendStatus';

class GuestSettingsInputGroup extends Component {

  handleChange = (e) => {
    this.props.onChange(this.props.name, e.target.value);
  };

  render() {
    return (
      <FormGroup row>
        <Label sm={3}>{this.props.label}</Label>
        <Col sm={9}>
          <Input
            type="text"
            placeholder={this.props.placeholder}
            onChange={this.handleChange}
            value={this.props.value}
          />
        </Col>
      </FormGroup>
    );
  }
}

class GuestSettingsRow extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      name: '',
      email: '',
      phoneNumber: '',
      contactMethod: null,
    };
  }

  componentDidMount() {
    this._updateInputValues();
  }

  componentWillReceiveProps(newProps) {
    this._updateInputValues();
  }

  _updateInputValues() {
    if (!this.props.guest) {
      return;
    }
    this.setState({
      name: this.props.guest.first_name+' '+this.props.guest.last_name,
      email: this.props.guest.email,
      phoneNumber: this.props.guest.phone_number,
      contactMethod: this.props.guest.contact_method,
    });
  }

  _handleInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  _handleSubmit = e => {
    e.preventDefault();
    const data = {
      email: this.state.email,
      phone_number: this.state.phoneNumber,
      contact_method: this.state.contactMethod,
    };
    if (this.props.guest.mutable) {
      const idxSpace = this.state.name.indexOf(' ');
      data.first_name = idxSpace > 0 ? this.state.name.substr(0, idxSpace) : this.state.name;
      data.last_name = idxSpace > 0 ? this.state.name.substr(idxSpace + 1) : '';
    }
    this.setState({
      sendStatus: 'sending',
    });
    Api.putGuestInfo(this.props.guest.guest_id, data)
      .then(response => {
        if (response.error) {
          alert('There was a problem saving your contact info. Please try again.');
        }
        this.setState({
          sendStatus: response.error ? 'error' : 'sent',
        });
      });
  }

  render() {
    const guest = this.props.guest;
    return (
      <tr key={'guest-contact-'+guest.guest_id}>
        <td className="align-middle">
          <Form onSubmit={this._handleSubmit}>
            {guest.mutable ? (
            <GuestSettingsInputGroup
              label="Guest name"
              placeholder="Guest name"
              name="name"
              value={this.state.name}
              onChange={this._handleInputChange}
            />
            ): (
            <FormGroup row>
              <Col>{guest.first_name+' '+guest.last_name}</Col>
            </FormGroup>
            )}
            <GuestSettingsInputGroup
              label="Email"
              placeholder="Email address"
              name="email"
              value={this.state.email}
              onChange={this._handleInputChange}
            />
            <GuestSettingsInputGroup
              label="Cell"
              placeholder="Phone number"
              name="phoneNumber"
              value={this.state.phoneNumber}
              onChange={this._handleInputChange}
            />
            <FormGroup row>
              <Col xs={4} sm={3} className="align-middle">
                <span className="card-third-label">Prefer</span>
              </Col>
              <Col xs={8} sm={9}>
                <Label check className="mr-3">
                  <Input
                    type="radio"
                    name="prefer_email"
                    checked={this.state.contactMethod==='email'}
                    onChange={() => this.setState({contactMethod: 'email'})}
                  />
                  {' '}
                  Email
                </Label>
                <Label check>
                  <Input
                    type="radio"
                    name="prefer_phone"
                    checked={this.state.contactMethod==='phone'}
                    onChange={() => this.setState({contactMethod: 'phone'})}
                  />
                  {' '}
                  Text
                </Label>
              </Col>
            </FormGroup>
            <FormGroup row className="justify-content-end">
              <Col xs={4} sm={3} className="text-right">
                <SendStatus sendStatus={this.state.sendStatus} style={{marginTop:'.35rem'}}/>
              </Col>
              <Col xs={8} sm={9}>
                <Button
                  color="secondary"
                  size="md"
                  type="submit"
                  style={{paddingBottom:'.2rem'}}
                >Save</Button>
              </Col>
            </FormGroup>
          </Form>
        </td>
      </tr>
    );
  }
}

class GuestSettingsCard extends Component {

  render() {
    return (
      <Card className="card-third mt-3">
        <CardBlock>
          <CardTitle className="mt-3" style={{fontSize: '1.75rem', paddingLeft:'.75rem'}}>Your guest info</CardTitle>
          <Table className="mb-0">
            <tbody>
              {this.props.guests.map(guest => (
              <GuestSettingsRow
                key={'guest-contact-info-'+guest.guest_id}
                guest={guest}
                mealChoices={this.props.mealChoices}
              />
              ))}
            </tbody>
          </Table>
        </CardBlock>
      </Card>
    );
  }
}

export default GuestSettingsCard;



// WEBPACK FOOTER //
// ./src/Welcome/GuestSettings.js